webpackJsonp([6],{

/***/ "./src/app/data/screenshots/pingusenglish/home.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/home.2512b083.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/pingusenglish/kindergarten.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kindergarten.89e94798.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/pingusenglish/newsroom.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/newsroom.2d8f87b9.jpg";

/***/ }),

/***/ "./src/app/data/screenshots/pingusenglish/parents.jpg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/parents.05398291.jpg";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/work/pingusenglish.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__("./node_modules/rebass/dist/index.js");
	
	var _link = __webpack_require__("./src/app/components/link/index.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _slider = __webpack_require__("./src/app/components/slider/index.js");
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _Details = __webpack_require__("./src/Details/index.js");
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _Lead = __webpack_require__("./src/Lead/index.js");
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _home = __webpack_require__("./src/app/data/screenshots/pingusenglish/home.jpg");
	
	var _home2 = _interopRequireDefault(_home);
	
	var _newsroom = __webpack_require__("./src/app/data/screenshots/pingusenglish/newsroom.jpg");
	
	var _newsroom2 = _interopRequireDefault(_newsroom);
	
	var _kindergarten = __webpack_require__("./src/app/data/screenshots/pingusenglish/kindergarten.jpg");
	
	var _kindergarten2 = _interopRequireDefault(_kindergarten);
	
	var _parents = __webpack_require__("./src/app/data/screenshots/pingusenglish/parents.jpg");
	
	var _parents2 = _interopRequireDefault(_parents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = [{
	  src: _home2.default,
	  alt: 'Pingu\'s English home page'
	}, {
	  src: _newsroom2.default,
	  alt: 'Pingu\'s English news page'
	}, {
	  src: _kindergarten2.default,
	  alt: 'Pingu\'s English page design - kindergarten'
	}, {
	  src: _parents2.default,
	  alt: 'Pingu\'s English page design - parents'
	}];
	
	var tags = ['Education', 'Wordpress', 'HTML', 'CSS', 'Javascript', 'Website Deployment'];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Details2.default,
	      {
	        title: 'Pingusenglish',
	        subtitle: 'Education'
	      },
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83D\uDC27', title: 'A beautiful and fun website' },
	        _react2.default.createElement(
	          _link2.default,
	          { target: '_blank', href: 'http://pingusenglish.com.cy/' },
	          'Pingu\'s English'
	        ),
	        ' needed a website to promote their innovative program for early stage children, which combines english language teaching with entertainment. Their vision was to create a great looking web presence, that is inline with their branding, and can accommodate the vast amount of information about their product, without sacrificing usability.'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\u2764\uFE0F', title: 'Who said Wordpress?' },
	        'We worked together with Pingu\'s English Cyprus to develop a Wordpress-based solution that allows to easily self-manage their website. Using a simple and easy-to-use interface, our client is now able to post news articles, images & video, create new pages, and manage accounts. No technical skills required. \uD83D\uDE4C'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83C\uDF10', title: 'A global English teaching program for children' },
	        'Pingu\'s English is a franchise operation founded in 2008 and is established in over 20 countries around the world, including UK, Italy, China, Singapore, and Japan.'
	      ),
	      _react2.default.createElement(_Details2.default.Tags, {
	        tags: tags,
	        width: '100%'
	      }),
	      _react2.default.createElement(_slider2.default, { images: images }),
	      _react2.default.createElement(
	        _rebass.Box,
	        { mt: 5 },
	        _react2.default.createElement(_Lead2.default, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-work-pingusenglish-js-9c0193b5dbc3c4fef1f5.js